module.exports = __webpack_public_path__ + "media/images/camo_small-f923e6e1.gif";